// 订单管理
import {
    axiospost,
    axiosget,
    // axiosposts
} from './axios';


// 订单列表
export const getOrderList = (params) => axiosget('/sys/orderManagement/getAntOrderListPage', params)
// 新建会员
export const addMember = (params) => axiospost('/sys/orderManagement/addMemberAndOrder', params)
// 创建订单
export const addOrder = (params) => axiospost('/sys/orderManagement/addOrder', params)
// 取消订单
export const cancelOrder = (params) => axiosget('/sys/orderManagement/cancelOrderBasic', params)
//保存订单信息
export const addOrderDetails = (params) => axiospost('/sys/orderManagement/addOrderDetails', params)
// 订单详情
export const getOrderDetail = (params) => axiosget('/sys/orderManagement/getOrderDetail', params)
// 结算返回结算信息
export const getsettlementReturnsBillingInformation = (params) => axiosget('/sys/orderManagement/settlementReturnsBillingInformation', params)
// 结算

export const confirmPayment = (params) => axiospost('/sys/orderManagement/confirmPayment', params)
// 成绩录入
export const gradeInPayment = (params) => axiospost('/sys/orderManagement/typeInMemberScore', params)
// 成绩录入回显
export const getMemberScoreByOrder = (params) => axiosget('/sys/orderManagement/getMemberScoreByOrder',params)
// 比赛录入
export const typeInMemberGameScore = (params) => axiospost('/sys/orderManagement/typeInMemberGameScore', params)
// 比赛录入回显
export const getGameScoreListByOrder = (params) => axiosget('/sys/orderManagement/getGameScoreListByOrder',params)
// 订单编号模糊查询
export const getOrderNumberList = (params) => axiosget('/sys/orderManagement/getOrderNumberList',params)






// 查询物品寄存列表
export const getStorageRegisterList = (params) => axiosget('/sys/orderManagement/getStorageRegisterList', params)
// 创建物品寄存
export const addStorageRegister = (params) => axiospost('/sys/orderManagement/addStorageRegister', params)
// 退租
export const refundDeposit = (params) => axiospost('/sys/orderManagement/refundDeposit', params)
// 续约
export const renew = (params) => axiospost('/sys/orderManagement/renew', params)
// 寄存类型字典（挂钩、箱柜）
export const getStorageType = () => axiosget('/sys/dict/getDictItems/storage_type')


// 新建会员-会员分组下拉
export const getOldDeptForSelect = () => axiosget('/sys/membersManagement/getOldDeptForSelect')
// 新建会员-会员荣耀多选
export const getHonourList = () => axiosget('/sys/businessManage/getHonourList')
// 根据会员电话(姓名)查找会员信息--创建订单-模糊下拉
export const getMembersInfo = (params) => axiosget('/sys/membersManagement/getAntMembersForSelect', params)
// 获取账号下拉--创建订单-创建人下拉
export const getUserForSelect = (params) => axiosget('/sys/businessManage/getCoachListForSelect', params)
// 根据会员id获取会员详情--创建订单-获取会员详情
export const getMemberById = (params) => axiosget('/sys/membersManagement/getAntMemberById', params)
// // 升卡
// export const getUpgradeCardList = (params) => axiosposts('/sys/businessManage/getUpgradeCardList', params)
// 升卡
export const getUpgradeCardList = (params) => axiosget('/sys/businessManage/getUpgradeCardList', params)
// 比赛下拉
export const getAntGameList = () => axiosget('/sys/operationManagement/getAntGameListForSelect')
// 获取米数字典
// export const meterType = () => axiosget('/sys/dict/getDictItems/meter_type')

// 订单管理--获取自定义项列表
export const getOrderCustomizationList = () => axiosget('/sys/orderManagement/getOrderCustomizationList')


// 删除订单
export const delorder = (params) => axiospost('/sys/orderManagement/voidOrder ', params)







